import React from 'react';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';
import PricesSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Summary/PricesSummaryProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const PricesSummaryPage = () => {
  return (
    <BasePageContainer>
      <Flex gap={BEACON_CHART_SPACING} flexDirection="column">
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAIL_PRICE.name}
          chartName={CHART_NAMES.BEACON_RETAIL_PRICE_SPLINE}
        >
          <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="retailPrice" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_WHOLESALE_PRICE.name}
          chartName={CHART_NAMES.BEACON_WHOLESALE_PRICE_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="wholesalePrice" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BRAND_COGS_PER_UNIT.name}
          chartName={CHART_NAMES.BEACON_BRAND_COGS_PER_UNIT_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="brandCogsPerUnit" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BRAND_GROSS_MARGIN_PER_UNIT.name}
          chartName={CHART_NAMES.BEACON_BRAND_GROSS_MARGIN_PER_UNIT_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMarginPerUnit" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAIL_PRICE_BY_ENTITY.name}
          chartName={CHART_NAMES.BEACON_RETAIL_PRICE_BY_ENTITY_COLUMN}
        >
          <BeaconDropdownMetricColumnChart
            beaconChartWithLegendPropsBuilder={(props) => ({
              ...props,
              loadingComponent: <TopEntityChartV2Loading />
            })}
            indexName="sales"
            fieldName="retailPrice"
            dropdownOptions={[
              {
                id: 'subCategoryId',
                label: 'Subcategory'
              },
              {
                id: 'categoryId',
                label: 'Category'
              },
              {
                id: 'brandId',
                label: 'Brand'
              }
            ]}
            titlePrefix="Retail Price by"
          />
        </ChartContextProvider>
        <PricesSummaryProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default PricesSummaryPage;
